@if (rule) {
  <div class="rule-builder-container">
    <!-- Compound Rule Group -->
    @if (rule.type === 'compound') {
      <div class="rule-group">
        <div class="group-header">
          <mat-button-toggle-group [(ngModel)]="rule.operator" (ngModelChange)="emitRuleChange()" class="group-condition query-builder-toggle-buttons">
            <mat-button-toggle value="and">AND</mat-button-toggle>
            <mat-button-toggle value="or">OR</mat-button-toggle>
          </mat-button-toggle-group>
          <div class="group-actions">
            <button mat-button class="text-btn" (click)="addRule(rule)">+ Add Rule</button>
            <button mat-button class="text-btn" (click)="addRuleSet(rule)">+ Add Group</button>
          </div>
        </div>
        <div class="rules-area">
          @for (subRule of rule.rules; track subRule; let i = $index) {
            <div
              class="rule-or-group-wrapper"
              [ngClass]="{'contradiction': (path ? (path + '.rules.' + i) : ('rules.' + i)) === contradiction?.path}">
              <rule-builder
                [rule]="subRule"
                (ruleChange)="emitRuleChange()"
                [contradiction]="contradiction"
                [availableCPIds]="availableCPIds"
                [path]="path ? (path + '.rules.' + i) : ('rules.' + i)"
              ></rule-builder>
              <button mat-icon-button color="warn" class="remove-rule-button" (click)="removeRule(rule, i)" matTooltip="Remove rule/group">
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          }
        </div>
      </div>
    }
    <!-- Single Rule Editor -->
    @if (rule.type !== 'compound') {
      <div class="rule-row">
        <mat-form-field>
          <mat-label>Rule Type</mat-label>
          <mat-select [(ngModel)]="rule.type" (ngModelChange)="onRuleTypeChange($event)">
            @for (type of ruleTypes; track type) {
              <mat-option [value]="type.value">{{ type.viewValue }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        <!-- Field Selector (Conditional) -->
        @if (rule.type === 'attribute_value') {
          <mat-form-field class="rule-field-select">
            <mat-label>Attribute</mat-label>
            <mat-select [(ngModel)]="rule.attribute" (ngModelChange)="onAttributeChange($event)">
              @for (attr of commonAttributes; track attr) {
                <mat-option [value]="attr">{{ attr | removeUnderscore | titlecase }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        }
        @if (rule.type === 'component_attribute_value') {
          <mat-form-field class="rule-field-select">
            <mat-label>Component Attribute</mat-label>
            <mat-select [(ngModel)]="rule.attribute" (ngModelChange)="onAttributeChange($event)">
              @for (attr of componentAttributes; track attr) {
                <mat-option [value]="attr">{{ attr | removeUnderscore | titlecase }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        }
        @if (rule.type === 'event_attribute_value') {
          <mat-form-field class="rule-field-select">
            <mat-label>Event Attribute</mat-label>
            <mat-select [(ngModel)]="rule.attribute" (ngModelChange)="onAttributeChange($event)">
              @for (attr of eventAttributes; track attr) {
                <mat-option [value]="attr">{{ attr | removeUnderscore | titlecase }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        }
        <!-- CP Selector -->
        @if (rule.type === 'cp_value') {
          <div class="rule-field-select">
            <select-search-component
              [value]="selectedConstantProperty"
              [api_model]="'constant_property_light'"
              [custom_filters]="cpSearchFilters"
              (selectionChange)="onCPSelected($event.value)"
              label="Constant Property"
              [classes]="'fill'"
              class="select-search">
            </select-search-component>
          </div>
        }
        <!-- Operator Selector -->
        <mat-form-field>
          <mat-label>Operator</mat-label>
          <mat-select [(ngModel)]="rule.operator" (ngModelChange)="emitRuleChange()">
            @for (op of getOperators(getFieldType(rule)); track op) {
              <mat-option [value]="op">{{ operatorDesc[op] }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        <!-- Value Input -->
        @switch (getFieldType(rule)) {
          @case ('string') {
            <mat-form-field>
              <mat-label>Value</mat-label>
              <input matInput [(ngModel)]="rule.value" (ngModelChange)="emitRuleChange()">
            </mat-form-field>
          }
          @case ('number') {
            <mat-form-field>
              <mat-label>Value</mat-label>
              <input matInput type="number" [(ngModel)]="rule.value" (ngModelChange)="emitRuleChange()">
            </mat-form-field>
          }
          @case ('datetime') {
            <div class="date-input-container">
              <mat-button-toggle-group [(ngModel)]="dateMode" (ngModelChange)="emitRuleChange()" exclusive class="query-builder-toggle-buttons">
                <mat-button-toggle value="relative">Relative</mat-button-toggle>
                <mat-button-toggle value="absolute">Absolute</mat-button-toggle>
              </mat-button-toggle-group>
              @if (dateMode === 'absolute') {
                <div class="date-picker-container">
                  <label for="picker">Choose a date</label>
                  <date-time-picker
                    id="picker"
                    [input_date]="rule.value"
                    (date_changed)="rule.value = $event; emitRuleChange()"
                    [show_time]="true"
                    [placeholder]="'Select date and time'"
                    [classes]="'fill date-picker'"
                  ></date-time-picker>
                </div>
              }
              @if (dateMode === 'relative') {
                <div class="relative-date-rule-input">
                  <mat-form-field>
                    <mat-label>Amount</mat-label>
                    <input matInput type="number" min="1"
                      [(ngModel)]="relativeAmount"
                      (ngModelChange)="updateRelativeDateString()">
                  </mat-form-field>
                  <mat-form-field>
                    <mat-label>Unit</mat-label>
                    <mat-select [(ngModel)]="relativeUnit" (ngModelChange)="updateRelativeDateString()">
                      <mat-option value="day">Day(s)</mat-option>
                      <mat-option value="week">Week(s)</mat-option>
                      <mat-option value="month">Month(s)</mat-option>
                    </mat-select>
                  </mat-form-field>
                  <mat-form-field>
                    <mat-label>Direction</mat-label>
                    <mat-select [(ngModel)]="relativeDirection" (ngModelChange)="updateRelativeDateString()">
                      <mat-option value="ago">Ago</mat-option>
                      <mat-option value="from_now">From now</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              }
            </div>
          }
          @case ('component_type') {
            <div>
              <select-search-component
                [value]="selectedComponentType"
                [api_model]="'component_type'"
                (selectionChange)="onComponentTypeSelected($event.value)"
                label="Component Type"
                [classes]="'fill'"
                class="select-search">
              </select-search-component>
            </div>
          }
          @case ('event_type') {
            <div>
              <select-search-component
                [value]="selectedEventType"
                [api_model]="'event_type'"
                (selectionChange)="onEventTypeSelected($event.value)"
                label="Event Type"
                [classes]="'fill'"
                class="select-search">
              </select-search-component>
            </div>
          }
        }
      </div>
    }
    @if ((path || 'rules') === contradiction?.path && rule.type !== 'compound') {
      <p
        class="contradiction-warning"
        matTooltip="This rule causes a contradiction."
        >
        {{ contradiction?.reason }}
      </p>
    }
  </div>
} @else {
  <button mat-raised-button color="primary" (click)="initializeRule()">+ Add Initial Rule</button>
}

<!-- Initial Add Rule Button -->
